/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import toastr from 'toastr';
import { Base64 } from 'js-base64';
import { FaTrashAlt } from 'react-icons/fa';
import {
  FormGroup,
  Form,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import { injectIntl, intlShape } from 'react-intl';
import styled from 'styled-components';
import ColorInput from '../components/forms/ColorInput';

import Content from '../components/layout/Content';
import FormError from '../components/formControls/FormError';
import SnipperButton from '../components/buttons/SpinnerButton';
import { IMG_URL } from '../config';
import { getSettings, updateGeneralSettings, deleteLogo } from '../api/settings';
import EscapeChars from '../helpers/regex';

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      settings: '',
      imageUrl: '',
    };
  }

  async componentDidMount() {
    const { intl, user } = this.props;
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const res = await getSettings({ masterUser });

    this.setState({ settings: res.data.settings, masterUser }, () => {
      const { settings } = this.state;
      if (masterUser) {
        const path = `${IMG_URL}${Base64.encode(masterUser)}/images/${settings.logo}`;
        try {
          if (settings.logo !== '') {
            this.setState({ imageUrl: path });
          }
        } catch (err) {
          console.error(err);
        }
      }
    });
  }

  async deleteLogoHandler() {
    const { masterUser } = this.state;
    await deleteLogo(masterUser, 'logo').then((result) => { }, (error) => {
      console.log('error', error);
      console.log(error.response);
    }).catch((error) => {
      console.log('catch error', error);
    });
    this.setState({ imageUrl: '' });
    toastr.success('', 'Logo Deleted');
  }

  render() {
    const { intl } = this.props;
    const {
      loading, settings, masterUser, imageUrl,
    } = this.state;

    const generalSettingsText = intl.formatMessage({ id: 'settings.generalsettings' });
    const generalSettingsSavedText = intl.formatMessage({ id: 'settings.generalsettings.saved' });
    const categoryPositionText = intl.formatMessage({ id: 'settings.categoryposition' });
    const verticalText = intl.formatMessage({ id: 'settings.categoryposition.vertical' });
    const horizontalText = intl.formatMessage({ id: 'settings.categoryposition.horizontal' });
    const idleTimerText = intl.formatMessage({ id: 'settings.idletimer' });
    const idleTimerDescText = intl.formatMessage({ id: 'settings.idletimerdesc' });
    const exampleFontText = intl.formatMessage({ id: 'settings.examplefont' });
    const imageScaleText = intl.formatMessage({ id: 'image.scale' });
    const saveText = intl.formatMessage({ id: 'save' });
    const themeColor = intl.formatMessage({ id: 'settings.themeColor' });
    return (
      <Row>
        <link href="https://fonts.googleapis.com/css?family=Anton|Gayathri|Lato|Manjari|Open+Sans|Roboto&display=swap" rel="stylesheet" />
        <Col>
          <Formik
            initialValues={{
              categoryPosition: settings.categoryPosition, font: settings.font, idleTime: settings.idleTime, themeColor: settings.themeColor,
            }}
            enableReinitialize
            onSubmit={async (data) => {
              const formData = new FormData();
              const imagefile = document.querySelector('#logo');
              if (imagefile.files[0] !== undefined) {
                formData.append('logo', imagefile.files[0], EscapeChars(imagefile.files[0].name));
                imagefile.value = '';
              }
              formData.append('categoryPosition', data.categoryPosition);
              formData.append('idleTime', data.idleTime);
              formData.append('font', data.font);
              formData.append('themeColor', data.themeColor);
              await updateGeneralSettings(masterUser, formData);
              toastr.success(generalSettingsSavedText);
            }}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              /* and other goodies */
            }) => (
              <Content title={generalSettingsText}>
                  <Form onSubmit={handleSubmit}>
                    <ColorInput
                      id="themeColor"
                      name="themeColor"
                      placeholder="Theme Color"
                      type="text"
                      onChange={(value, name) => setFieldValue('themeColor', value)}
                      label={themeColor}
                      value={values.themeColor}
                      color=""
                    />
                    <FormGroup>
                      <Label for="idleTime">{idleTimerText}</Label>
                      <Input
                        type="text"
                        name="idleTime"
                        id="idleTime"
                        onChange={handleChange}
                        value={values.idleTime}
                      />
                      <small>{idleTimerDescText}</small>
                      {errors.name && <FormError error={errors.name} />}
                    </FormGroup>
                    <FormGroup>
                      <Label for="categoryPosition">Font</Label>
                      <Input
                        type="select"
                        name="font"
                        id="font"
                        onChange={handleChange}
                        value={values.font}
                      >
                        <option value="Roboto">Roboto</option>
                        <option value="Gayathri">Gayathri</option>
                        <option value="Manjari">Manjari</option>
                        <option value="Open Sans">Open Sans</option>
                        <option value="Lato">Lato</option>
                        <option value="Anton">Anton</option>
                        >
                      </Input>
                      {errors.name && <FormError error={errors.name} />}
                      <p style={{ fontFamily: values.font, marginTop: 10 }} id="textdiv" suppressContentEditableWarning contentEditable>{exampleFontText}</p>
                    </FormGroup>
                    <FormGroup>
                      <Label for="logo">Logo</Label>
                      <Input
                        type="file"
                        name="logo"
                        id="logo"
                        onChange={(event) => {
                          this.setState({ imageUrl: URL.createObjectURL(event.target.files[0]) });
                          setFieldValue('logo', event.currentTarget.files[0]);
                        }}
                      />
                      <div>
                        <small>{imageScaleText}</small>
                      </div>
                      <ImageWrapper>
                        <PreviewImg id="previewImage" src={imageUrl || ''} alt="" />
                        {imageUrl
                          && <DeleteButton onClick={() => this.deleteLogoHandler()} />}
                      </ImageWrapper>
                    </FormGroup>

                    <SnipperButton type="submit" loading={loading} text={saveText} />
                  </Form>
                </Content>
            )}
          </Formik>
        </Col>
      </Row>
    );
  }
}

Settings.propTypes = {
  intl: intlShape.isRequired,
};

const PreviewImg = styled.img`
  margin-top: 20px;
  width: 200px;
`;
const DeleteButton = styled(FaTrashAlt)`
  position: absolute;
  top: 0; 
  right: 20px;
  cursor: pointer;
`;
const ImageWrapper = styled.div`
  display: inline-block;
  position: relative;
  margin-top: 40px;

`;

const mapStateToProps = (state) => ({ user: state.auth.user });

export default injectIntl(connect(mapStateToProps)(Settings));
